import React, { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { message } from "antd";
import { LoginAction } from "redux/actions";
import { UTILS, TRACKING_EVENTS } from "utils";
import { CONSTANTS as C } from "config";
import { ROUTES } from "config";
import { API } from "api";
import AuthLayout from "../../layout";
import StepsIndicator from "../../components/steps-indicator";
import AppButton from "components/ui/AppButton";
import { steps } from "./index";

const VerifyOTP = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { t } = useTranslation();
  const [isMounted, setIsMounted] = useState(false);
  const [state, setState] = useState({
    loading: false,
    values: {},
  });

  const [seconds, setSeconds] = useState(30);

  const [verificationCode, setVerificationCode] = useState({
    code1: "",
    code2: "",
    code3: "",
    code4: "",
  });

  const inputRefs = useRef([]);

  const handleChange = (e, index) => {
    const { name, value } = e.target;
    const digit = UTILS.NumberConversion(value).slice(-1);

    setVerificationCode((prev) => ({
      ...prev,
      [name]: digit,
    }));

    if (digit && index < 3) {
      inputRefs.current[index + 1]?.focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !verificationCode[`code${index + 1}`]) {
      if (index > 0) {
        inputRefs.current[index - 1]?.focus();
      }
    }
  };

  const validateOtp = () => {
    message.destroy();
    const code = Object.values(verificationCode).join("");
    if (code.length < 4) {
      message.error(t("Please provide a valid OTP code"));
      return false;
    }
    return true;
  };

  const handleSubmit = async () => {
    message.destroy();
    if (!validateOtp()) return;

    const code = Object.values(verificationCode).join("");
    const userDetail = UTILS.getCurrentUser();

    setState((prev) => ({ ...prev, loading: true }));

    const result = await API.VERIFY_MOBILE_NUMBER({
      verificationCode: code,
      phoneNumber: state?.values?.phoneNumber,
      language: state?.values?.baseLanguage === "ar" ? "AR" : "EN",
    });

    if (result?.success === 1 && result?.token) {
      message.success(result.message);
      UTILS.saveCurrentUser({ ...userDetail, token: result.token });
      dispatch(LoginAction.toogleLogin(true));

      TRACKING_EVENTS.verifiedRegistrations({
        user_id: userDetail?.userId,
      });

      setTimeout(() => {
        window.location.href =
          process.env.REACT_APP_COMPANY_NAME === C.COMPANY_NAMES.RESTHERO
            ? ROUTES.ONBOARDING
            : "/app/dashboard";
      }, 1500);
    } else {
      message.error(result?.message);
    }

    setState((prev) => ({ ...prev, loading: false }));
  };

  const resend_verification = async () => {
    message.destroy();
    setSeconds(30);
    setState((prevState) => ({
      ...prevState,
      loading: true,
    }));
    const result = await API.RESEND_VERIFICATION_CODE({
      phoneNumber: state?.values?.phoneNumber,
    });

    if (result && result?.success === 1) {
      let number = state?.values?.phoneNumber?.slice(1, 13);
      message.success(t("Code re-sent to") + ":" + number);
    } else {
      message.error(t("Please try again later"));
    }
    setState((prevState) => ({
      ...prevState,
      loading: false,
    }));
  };

  useEffect(() => {
    if (isMounted) {
      const state = history?.location?.state?.stateRegister?.values;
      if (state) {
        // const { stateRegister } = history?.location?.state;
        setState((prevState) => ({
          ...prevState,
          values: state,
        }));
      } else {
        history.goBack();
      }
    } else {
      setIsMounted(true);
    }
  }, [isMounted]);

  // useEffect(() => {
  //   if (Object.values(verificationCode).every((code) => code !== "")) {
  //     handleSubmit();
  //   }
  // }, [verificationCode]);

  useEffect(() => {
    let myInterval = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1);
      }
    }, 1000);
    return () => {
      clearInterval(myInterval);
    };
  }, [seconds]);

  useEffect(() => {
    requestAnimationFrame(() => {
      inputRefs.current[0]?.focus();
    });
  }, []);

  return (
    <AuthLayout
      loading={state?.loading}
      title={steps[3].title}
      description={
        <span>
          {t(steps[3].content)}{" "}
          {state?.values?.phoneNumber && (
            <a
              href={`https://wa.me/${state?.values?.phoneNumber}`}
              className="text-bright-blue underline"
            >
              {state?.values?.phoneNumber}
            </a>
          )}
        </span>
      }
      leftExtraContent={
        <StepsIndicator
          currentStep={3}
          totalSteps={Object.keys(steps).length}
          title={steps[3].title}
          content={steps[3].content}
        />
      }
    >
      <div className="flex-1 flex  h-full">
        <div className="flex gap-10 mt-16" dir="ltr">
          {Object.keys(verificationCode).map((key, index) => (
            <input
              key={key}
              ref={(el) => (inputRefs.current[index] = el)}
              name={key}
              type="text"
              placeholder=""
              maxLength={1}
              inputMode="numeric"
              autoComplete="off"
              style={{ height: "98px", width: "164px" }}
              className={`
                p-2 rounded-md text-center text-30px font-semibold text-black
                border-2 transition-all duration-200
                focus:outline-none
                ${verificationCode[key]
                  ? "border-4 border-bright-blue"
                  : "border-2 border-gray-300 focus:border-4 focus:border-bright-blue"
                }
              `}
              value={verificationCode[key]}
              onChange={(e) => handleChange(e, index)}
              onKeyDown={(e) => handleKeyDown(e, index)}
            />
          ))}
        </div>
      </div>
      {seconds > 0 ? (
        <div className="">
          <span className=" text-sm  text-15x ">
            {t("I haven't received the code")} •{" "}
            <span className="text-bright-blue">{seconds}</span> {t("sec")}
          </span>
        </div>
      ) : (
        <span
          className=" cursor-pointer "
          onClick={() => resend_verification()}
        >
          <span
            className="text-sm underline text-15x text-brand-base-primary group-hover:text-bright-blue 
        "
          >
            {t("I haven't received the code")}
          </span>
        </span>
      )}
      <AppButton
        onClick={handleSubmit}
        loading={state?.loading}
        disabled={state?.loading}
        className="w-full mt-5"
      >
        {t("Submit")}
      </AppButton>

      <div className="text-center">
        <p>
          <span className="text-19px text-silver-light">
            {t("Have trouble ? Call us at")}
          </span>
          <span
            className="font-lato bb text-19px text-silver-light  px-2"
            dir="ltr"
          >
            {process.env.REACT_APP_SUPPORT_MOBILE}
          </span>
        </p>
      </div>
      {/* Submit button example */}

    </AuthLayout>
  );
};

export default VerifyOTP;
